















import { Component, mixins } from '@niknevis/vue-modules'
import { InjectReactive } from 'vue-property-decorator'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import PanelContentItemActions from '@/modules/content-item/components/panel/table/PanelContentItemActions.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import { contentStatisticsCollectionType } from '@/modules/content-statistics/models/content-statistics.collection'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'

@Component({
  components: {
    TesTd,
    TesTr,
    PanelContentItemActions
  }
})
export default class AdminContentStatisticsTableRow extends mixins<TesTableRow>(TesTableRow) {
  @InjectReactive()
  contentStatistics!: contentStatisticsCollectionType

  // get withData(): ContentItemCollectionWith {
  //   return {
  //     statuses: this.items.statuses
  //   }
  // }

  get roles() {
    return this.row.roles.map(item => item.nicename).join(' , ')
  }

  get wordCount() {
    return Number(this.row.content_items_sum_writer_word_count + this.row.content_items_sum_editor_word_count)
      .toLocaleString()
  }

  columnComponents = {
    id: {
      component: AdminUserInfoButton,
      handler: (value, row) => ({ basicUser: { id: row.id, displayname: row.displayname } })
    },
    content_items_sum_writer_share: {
      component: PriceView,
      handler: (value, row) => ({ price: value, align: 'center', emptyLabel: 'عدم موجودی' })
    },
    content_items_sum_editor_share: {
      component: PriceView,
      handler: (value, row) => ({ price: value, align: 'center', emptyLabel: 'عدم موجودی' })
    },
    writer_wallet: {
      component: PriceView,
      handler: (value, row) => ({ price: value, align: 'center', emptyLabel: 'عدم موجودی' })
    }
  }
}
